<template>
  <div>
    <div style="font-size: 14px; color: #606266" class="mb-2">
      <span style="font-size: 14px; color: #606266"
        >Bill No：{{ formData.billCartonTransferNo || '' }}</span
      >
      <el-divider direction="vertical"></el-divider>
      <span>Status：{{ formData.v_cartonTransferStatus || '' }}</span>
      <el-divider direction="vertical"></el-divider>
      <span style="font-size: 14px; color: #606266">
        Create：{{ formData.createByName || '' }} at
        {{ formData.createTime || '' }}
      </span>
      <el-divider direction="vertical"></el-divider>
      <span style="font-size: 14px; color: #606266">
        Modify：{{ formData.modifyByName || '' }} at
        {{ formData.modifyTime || '' }}
      </span>
    </div>
    <el-form
      ref="form"
      size="small"
      :model="formData"
      :rules="rules"
      :disabled="disabled"
    >
      <el-row :gutter="20">
        <el-col :span="8">
          <el-form-item
            :label="$l('form_label_transferDate') || '转库日期'"
            prop="transferDate"
          >
            <el-date-picker
              v-model="formData.transferDate"
              type="datetime"
              size="small"
              value-format="yyyy-MM-dd HH:mm:ss"
              :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
              style="width: 100%"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="10">
          <el-form-item
            :label="$l('form_label_inLocationFull') || '转入库位'"
            prop="inLocationCode"
          >
            <el-cascader
              :options="treeData"
              :props="{
                emitPath: false,
                checkStrictly: true,
                value: 'code',
                label: 'label',
              }"
              size="small"
              ref="cascaderFunctionTreeRef"
              v-model="formData.inLocationCode"
              filterable
              clearable
              style="width: 100%"
              :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
            >
              <template slot-scope="{ node, data }">
                <span>{{ data.label }}</span>
                <span v-if="!node.isLeaf"> ({{ data.children.length }}) </span>
              </template>
            </el-cascader>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('form_label_locationNo') || '纸箱库位编号'"
            prop="locationNo"
          >
            <el-input
              v-model="formData.locationNo"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
              maxlength="50"
              clearable
              size="small"
              style="width: 100%"
              @change="getLocation"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <SampleTable
      class="mt-1"
      :tableData="tableData"
      :disabled="disabled"
      @delRow="delRow"
    ></SampleTable>

    <div class="d-flex justify-content-end mt-2 mb-2" v-if="!disabled">
      <el-button type="primary" size="small" @click="save()">
        {{ $l('INDEX.btn_save') || '保存' }}
      </el-button>
    </div>
  </div>
</template>
<script>
import SampleTable from './sample-table'
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
import dayjs from '@/libs/util.date'
import { mapActions } from 'vuex'

export default {
  mixins: [EditLoading],
  components: { SampleTable },

  props: {
    disabled: {
      default: true,
      type: Boolean,
    },
    billCartonTransferCode: {
      default: '',
      type: String,
    },
  },
  data() {
    return {
      tableData: [],
      formData: {
        transferDate: dayjs(new Date()).format('YYYY-MM-DD HH:mm:ss'),
        inLocationCode: '',
        billCartonTransferNo: '',
        billStatusName: '',
        createByName: '',
        createTime: '',
        modifyByName: '',
        modifyTime: '',
      },
      treeData: [],
      rules: {
        transferDate: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
            trigger: 'change',
          },
        ],
        inLocationCode: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
            trigger: 'change',
          },
        ],
      },
    }
  },
  mounted() {
    this.getTreeData()
    this.getData()
  },

  computed: {
    locationNoList() {
      return this.tableData.map((e) => e.locationNo)
    },
  },
  methods: {
    ...mapActions('admin/page', ['close']),
    getTreeData() {
      this.$api
        .warehouseTreeApi({ isLast: 'N' })
        .then((res) => {
          this.treeData = res.body.data
        })
        .catch(() => {})
    },
    getData() {
      if (this.billCartonTransferCode) {
        this.$api
          .billCartonTransferDetailApi({
            billCartonTransferCode: this.billCartonTransferCode,
          })
          .then((res) => {
            this.formData = res.body
            this.tableData = this.formData.boxList
          })
          .catch(() => {})
      }
    },

    async save() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) {
        return
      }
      if (!this.tableData || !this.tableData.length) {
        this.$message.warning(
          this.$l('tip_cannot_be_empty') || '纸箱库位信息不能为空'
        )
        return
      }
      this.loadingOpen()
      this.$api
        .billCartonTransferSaveApi({
          ...this.formData,
          boxList: this.tableData,
        })
        .then(() => {
          this.loadingClose()
          this.$alert(
            this.$l('INDEX.tips_save_ok') || '保存成功',
            this.$l('INDEX.tips_question_title') || '提示信息',
            {
              confirmButtonText:
                this.$l('INDEX.product_dialog_btn_confirm') || '确定',
              callback: () => {
                this.closeCurPage()
              },
            }
          )
        })
        .catch(() => {
          this.loadingClose()
        })
    },

    async closeCurPage() {
      // 关闭当前页面
      await this.close({
        tagName: this.$route.fullPath,
        showConfirm: false,
      })
    },

    getLocation() {
      if (
        this.formData.locationNo &&
        this.locationNoList.indexOf(this.formData.locationNo) == -1
      ) {
        this.$api
          .billCartonTransferBoxFindApi({
            locationNo: this.formData.locationNo,
          })
          .then((res) => {
            this.tableData = this.tableData.concat([res.body] || [])
            this.formData.locationNo = ''
          })
          .catch(() => {
            this.formData.locationNo = ''
          })
      } else {
        this.formData.locationNo = ''
      }
    },
    delRow(rowId) {
      this.tableData.splice(rowId, 1)
    },
  },
}
</script>
